import { NavigateFunction } from "react-router-dom";
import { TReactSetState, TUseTranslationTfn } from "../../data/AppType";
import {
  decryptData,
  handleError,
  toastError,
  toastSuccess,
} from "../../utils/AppFunctions";
import { routeAdmin, routeMaster } from "../../routes/AuthRoutePath";
import { localStorageUtils } from "../../utils/LocalStorageUtil";
import { routePublic } from "../../routes/PublicRoutePath";
import {
  RESEND_OTP,
  VERIFY_FORGOT_OTP,
  VERIFY_OTP,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { BIT_VALUE } from "../../utils/AppEnumerations";

interface IOtpForm {
  username: string;
  otp?: string;
}

export const initialValuesOtp = {
  username: "",
  otp: "",
};

export const submitOtpApi = async (
  values: IOtpForm,
  navigation: NavigateFunction,
  setLoading: TReactSetState<boolean>,
  t: TUseTranslationTfn,
  isForgot: string
) => {
  setLoading(true);
  try {
    const { username, otp } = values;
    const payload = {
      username: username,
      otp: otp,
    };

    if (isForgot === BIT_VALUE.One) {
      const forgotOtpVerify = await VERIFY_FORGOT_OTP(payload);
      if (
        forgotOtpVerify &&
        forgotOtpVerify.code === DEFAULT_STATUS_CODE_SUCCESS
      ) {
        navigation(`/${routePublic.resetPassword}?at=${forgotOtpVerify.data}`);
      } else {
        toastError(
          t(forgotOtpVerify.message || MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED)
        );
      }
    } else {
      const otpVerify = await VERIFY_OTP(payload);

      if (otpVerify && otpVerify.code === DEFAULT_STATUS_CODE_SUCCESS) {
        const token = JSON.parse(decryptData(otpVerify.data));
        localStorageUtils.setAccessToken(token.token);
        localStorageUtils.setRefreshToken(token.refresh_token);
        toastSuccess(t(otpVerify.message));
        navigation(`/${routeMaster.admin}/${routeAdmin.dashboard}`);
      } else {
        toastError(
          t(otpVerify.message || MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED)
        );
      }
    }
  } catch (error: any) {
    handleError(error, "submitOtpApi");
  } finally {
    setLoading(false);
  }
};
export const resendOtpApi = async (values: IOtpForm, t: TUseTranslationTfn) => {
  try {
    const { username, otp } = values;
    const payload = {
      username: username,
      otp: otp,
    };

    const forgotOtpVerify = await RESEND_OTP(payload);
    if (
      forgotOtpVerify &&
      forgotOtpVerify.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      toastSuccess(t(forgotOtpVerify.message));
    } else {
      toastError(
        t(forgotOtpVerify.message || MESSAGE_LOCAL_UNKNOWN_ERROR_OCCURRED)
      );
    }
  } catch (error: any) {
    handleError(error, "resendOtpApi");
  }
};
